<template>
  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container">
      <img src="@/assets/images/logo-智播.svg" class="logo" alt="logo" />
      <!-- <div class="user-layout-lang">
        <select-lang class="select-lang-trigger" />
      </div> -->
      <div class="contents">
        <div class="left">
          <div class="sub-title"><span style="color: #165dff">登录</span> 即可享受</div>
          <div class="key-features">
            <div class="feature" v-for="(item, index) in keyFeatures" :key="index">
              <img :src="item.icon" alt="" />
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="user-layout-content">
          <!-- <div class="top">
          <div class="header"></div>
          <div class="desc"></div>
        </div> -->
          <div class="login-title">
            <!--  -->
            <!-- <span class="title-text">MetaWorks Platform</span> -->
          </div>
          <router-view />
        </div>
      </div>
      <div class="footer">
        <div class="copyright" @click="toOuter">
          <span> 备案号：京ICP备2024041875号-1 copyright &copy; 2024 北京元客方舟科技有限公司 </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'
import SelectLang from '@/components/SelectLang'
import goodsIcon from '@/assets/images/商品.svg'
import cloudIcon from '@/assets/images/云.svg'
import AiIcon from '@/assets/images/AI大模型.svg'

export default {
  name: 'UserLayout',
  components: {
    SelectLang,
  },
  data() {
    return {
      keyFeatures: [
        {
          label: '商品一键上传',
          icon: goodsIcon,
        },
        {
          label: '支持云端开播',
          icon: cloudIcon,
        },
        {
          label: 'AI大模型实时互动',
          icon: AiIcon,
        },
      ],
    }
  },
  mixins: [deviceMixin],
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  },
  methods: {
    toOuter() {
      window.open('https://beian.miit.gov.cn/')
    },
  },
}
</script>

<style lang="less" scoped>
.sub-title {
  align-self: stretch;
  color: #000d4d;
  font-family: 'PingFang SC';
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
}

.other-login-register {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font: 14px/20px 'SourceHanSansSC-regular';
}
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-height: 100%;
    padding: 40px 0 24px 40px;
    // background: #f0f2f5;
    background-size: 100%;
    //padding: 50px 0 84px;
    position: relative;
    background-image: url('@/assets/images/bg.png');
    background-size: cover;
    .logo {
      height: 48px;
      width: 190px;
      vertical-align: top;
      margin-right: 16px;
      border-style: none;
    }
    .user-layout-lang {
      width: 100%;
      height: 40px;
      line-height: 44px;
      text-align: right;

      .select-lang-trigger {
        cursor: pointer;
        padding: 12px;
        margin-right: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        vertical-align: middle;
      }
    }
    .left {
      width: 384px;
      height: 510px;
      display: flex;
      flex-direction: column;
      margin-bottom: calc(195 / 1440 * 100vw);
      margin-left: calc(64 / 1440 * 100vw);
      color: #000d4dcc;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      .key-features {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 40px;
      }
      .feature {
        display: flex;
        img {
          width: 40px;
          height: 40px;
          margin-right: 16px;
        }
      }
    }
    .user-layout-content {
      // width: calc(384 / 1440 * 100vw);
      // height: calc(510 / 1440 * 100vw);
      // width: 384px;
      // height: 510px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border-radius: 16px;
      padding: 32px;
      // padding: calc(32 / 1440 * 100vw);
      background-color: #fff;
      box-shadow: 0 16px 48px 0 #165dff26;
      margin-right: 8.3vw;
      margin-bottom: calc(195 / 1440 * 100vw);
      .top {
        text-align: center;
        position: absolute;
        top: 50px;
        left: 50px;
        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, 0.85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
        background: #fff;
        padding: 50px 20px 20px 20px;
        margin-top: 100px;
      }
    }
    .footer {
      width: 100%;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          transition: all 0.3s;
          &:not(:last-child) {
            margin: 0 8px;
          }
        }
      }
      .copyright {
        font: 12px/18px 'SourceHanSansSC-regular';
        color: #87888a;
        cursor: pointer;
        span {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    .contents {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    a {
      text-decoration: none;
    }
  }
}
</style>
